import * as React from 'react';

import { OrganizationType } from 'globalTypes';
import PropTypes from 'prop-types';

// @ts-ignore
import RoleVerificationActions from 'actions/RoleVerificationActions';
// @ts-ignore
import { AdminRoleOptions, AdminRoles } from 'admin/constants/AdminRoles';
import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import DialogContent from 'components/DialogContent';
import FormDeprecated from 'components/FormDeprecated';
// @ts-ignore
import FormInput from 'components/FormInput';
// @ts-ignore
import FormSelect from 'components/FormSelect';
import Label from 'components/Label';
// @ts-ignore
import Radio from 'components/Radio';
// @ts-ignore
import SchoolPicker from 'components/SchoolPicker';
// @ts-ignore
import RoleVerificationStore from 'stores/RoleVerificationStore';

import { Backbone$Id } from 'types/typescript/Backbone';

import './styles/SetupAdmin.scss';

const EVENT_SCREEN_NAME = 'SetupAdminRoles';

type Props = {};

type State = {
  isSchool: boolean;
  role?: string;
  otherRole?: string;
  organizationId?: Backbone$Id;
};

class SetupAdmin extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static childContextTypes = {
    eventScreenName: PropTypes.string,
  };

  // REFACTOR I think we can remove props arg, but don't want to mess with
  // during BTS bug fixing
  constructor(props: Props) {
    super(props);
    const existingVerificationState: State = {
      isSchool: true,
    };
    const roleVerification = RoleVerificationStore.getRoleVerification();
    if (roleVerification) {
      existingVerificationState.isSchool = roleVerification.is_school;
      existingVerificationState.organizationId = roleVerification.organization_id;

      const currentRole = roleVerification.role;
      if (currentRole in AdminRoles) {
        existingVerificationState.role = currentRole;
      } else {
        existingVerificationState.role = 'other';
        existingVerificationState.otherRole = currentRole;
      }
    }

    this.state = existingVerificationState;
  }

  getChildContext() {
    return {
      eventScreenName: EVENT_SCREEN_NAME,
    };
  }

  onSelectOrg = (organizationId: Backbone$Id) => {
    this.setState({ organizationId });
  };

  submit = (attrs: { other_role?: string; role?: string }) => {
    const roleVerification = {
      organization_id: this.state.organizationId,
      is_school: this.state.isSchool,
      role: this.state.role === 'other' ? attrs.other_role : attrs.role,
    };

    RoleVerificationActions.addRoleVerification(roleVerification);
    this.context.router.push('/setup/school_email');
  };

  roleSelected = () => {
    if (this.state.role) {
      if (this.state.role === 'other') {
        return !!this.state.otherRole;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  renderOtherRole = () => {
    return (
      <div className="SetupAdmin-section">
        <FormInput
          label="Description"
          name={'other_role'}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            this.setState({ otherRole: event.target.value })
          }
          value={this.state.otherRole}
          placeholder="Describe your role"
        />
      </div>
    );
  };

  render() {
    const { isSchool, organizationId } = this.state;
    const organizationType: OrganizationType = isSchool
      ? OrganizationType.School
      : OrganizationType.District;

    return (
      <DialogContent size="small" className="SetupAdmin" title={'Where do you work?'}>
        <BoxBody divided>
          <div>
            <FormDeprecated onValidSubmit={this.submit}>
              <div className="SetupAdmin-section">
                <div className="SetupAdmin-affiliation">
                  <Radio
                    className="SetupAdmin-affiliation-radio"
                    label="At a school"
                    onChange={() => this.setState({ isSchool: true })}
                    checked={isSchool}
                  />
                  <Radio
                    className="SetupAdmin-affiliation-radio"
                    label="At a district"
                    onChange={() => this.setState({ isSchool: false })}
                    checked={!isSchool}
                  />
                </div>
              </div>

              <div className="SetupAdmin-section">
                <Label>What‘s the name of your {organizationType.toLowerCase()}?</Label>
                <SchoolPicker
                  organizationType={organizationType}
                  onSelect={this.onSelectOrg}
                  onClear={() => {}}
                  onCreateOrganization={(org: { id: string }) => this.onSelectOrg(org.id)}
                  schoolId={organizationId ? parseInt(String(organizationId), 10) : undefined}
                  placeholder={`Search for your ${organizationType.toLowerCase()}`}
                  showNCESId
                />
              </div>

              <div className="SetupAdmin-section">
                <FormSelect
                  label={`What‘s your role there?`}
                  name="role"
                  searchable={false}
                  options={AdminRoleOptions}
                  onChange={(role: string) => this.setState({ role })}
                  value={this.state.role}
                />
              </div>

              {this.state.role === 'other' && this.renderOtherRole()}

              <Button
                disabled={!this.state.organizationId || !this.roleSelected()}
                className="SetupAdmin-Submit"
                type="submit"
                eventProperties={{
                  is_school: isSchool,
                }}
                eventElementName="SetupAdmin-Submit">
                Next
              </Button>
            </FormDeprecated>
          </div>
        </BoxBody>
      </DialogContent>
    );
  }
}
export default SetupAdmin;
